<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="blank">
            <div class="text_wrap large">
              <p>"땡큐서울의원-내분비내과" 입니다.</p>
            </div>
            <div class="smallBtnWrap">
              <button onclick="location.href='tel:15228775'"><img src="@/assets/images/call_white.svg">전화걸기</button>
            </div>
            <div class="text_wrap red">
              <h2>1522-8775</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
export default {
  data () {
    return {
      transDate: {
        headerName: '전화번호 안내',
        prevUrl: '/'
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  methods: {
    callPrev () {
      if (this.setCount) {
        this.$router.push('/')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    }
  },
  components: {
    AppHeader,
    AppSidebar
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
</style>
